if($('.type-detail').length){

    $(".availability-value .availability-label").each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })
    $('.delivery-time').each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })
    $('.p-info-wrapper').append('<div class="availRow"></div><div class="kosik"></div>')
    if($('.delivery-time').length){
        $('.delivery-time').closest('tr').hide();
        $('.availRow').append('<div class="deliveryDate">Můžeme doručit do: <strong>'+$('.delivery-time').html()+'</strong></div>')
        $('.availRow').append($('.delivery-time').closest('tr').find('.shipping-options'))
    }
    else{
        $('.availRow').append($('.shipping-options'))
        
    }
    $('.availRow').append($('.availability-value'))

    $('.basic-description table').wrap('<div class="overflow-table"></div>')
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner-header h1').clone())
    $('.p-info-wrapper').append($('.p-detail-inner-header .p-code').clone())
    $('.p-info-wrapper').append($('.p-detail-info').clone())
  
   
    $('.kosik').append($('.p-final-price-wrapper'))
    $('.kosik').append($('.add-to-cart'))





    if($('.flag-konfigurator').length){
        if($('.surcharge-list').length){
            $('.surcharge-list').each(function(){
                var parameterId = $(this).find('select').data('parameter-id')
                var html = '<div class="custom-surcharge">'
                $(this).find('option').each(function(){
                    if ($.isNumeric($(this).val())) {
                        html += '<div class="inner" data-select-id="'+parameterId+'" data-value="'+$(this).attr('value')+'" data-price="'+$(this).attr('data-surcharge-final-price')+'">'
                            html += '<div class="image">'
                                html += '<img src="/user/documents/upload/'+imageFolder +"/a-" +$(this).attr('value') +'.jpg" alt="'+$(this).text().split('+')[0].trim()+'">'
                            html += '</div>'
                            html += '<div class="text">'
                                html += $(this).text().split('+')[0].trim()
                                html += '<span class="price">'+$(this).text().split('+')[1].trim()+'</span>'
                            html += '</div>'
                            if($('.admin-logged').length){
                                html += '<div class="admin-logged">'+$(this).attr('value')+'.jpg</div>'
                            }
                        html += '</div>'
                    }
                })
                html += '</div>'
                $(this).find('td').append(html)
            })
        }

        if($('.variant-list').length){
            $('.variant-list').each(function(){
                var parameterId = $(this).find('select').data('parameter-id')
                var html = '<div class="custom-variant" data-param-id="'+parameterId+'">'
                $(this).find('option').each(function(){
                    if ($.isNumeric($(this).val())) {
                        html += '<div class="inner" data-parameter-id="'+parameterId+'" data-value="'+$(this).attr('value')+'" data-price="'+$(this).attr('data-surcharge-final-price')+'">'
                            html += '<div class="image">'
                                html += '<img src="/user/documents/upload/'+imageFolder +"/a-" +$(this).attr('value') +'.jpg" alt="'+$(this).text().split('+')[0].trim()+'">'
                            html += '</div>'
                            html += '<div class="text">'
                                html += $(this).text()
                               // html += '<span class="price">'+$(this).text()+'</span>'
                            html += '</div>'
                            if($('.admin-logged').length){
                                html += '<div class="admin-logged">'+$(this).attr('value')+'.jpg</div>'
                            }
                        html += '</div>'
                    }
                })
                html += '</div>'
                $(this).find('td').append(html)
            })
            

            
        }
    
        if($('.products-related').length){
            $('.products-related-header, .products-related, .browse-p').hide()
            var htmlVylepseni = '<tr class="vylepseni"><th>Vylepšení exteriéru</th><td><div class="custom-surcharge">'
            $('.products-related .product').each(function(){
                var productName = $(this).find('.name').text()
                var productPrice = $(this).find('div[data-micro="offer"]').attr('data-micro-price')
                var productImage = $(this).find('a.image img').attr('data-src')
                var productSKU = $(this).find('span[data-micro="sku"]').text()
                htmlVylepseni += '<div class="inner dodatecne" data-price="'+productPrice+'" data-sku="'+productSKU+'">'
                    htmlVylepseni += '<div class="image">'
                        htmlVylepseni += '<img src="'+productImage+'" alt="'+productName+'">'
                    htmlVylepseni += '</div>'
                    htmlVylepseni += '<div class="text">'+productName+'<span class="price">'+Number(productPrice).ShoptetFormatAsCurrency()+'</span></div>'
                htmlVylepseni += '</div>'
            })
            htmlVylepseni += '</div></td></tr>'
            $('.surcharge-list').last().after(htmlVylepseni)
        }
        if($('#productsAlternative').length){
            $('li[data-testid="tabAlternativeProducts"]').hide()
            var htmlVylepseni = '<tr class="vylepseni"><th>Vylepšení interiéru</th><td><div class="custom-surcharge">'
            $('#productsAlternative .product').each(function(){
                var productName = $(this).find('.name').text()
                var productPrice = $(this).find('div[data-micro="offer"]').attr('data-micro-price')
                var productImage = $(this).find('a.image img').attr('data-src')
                var productSKU = $(this).find('span[data-micro="sku"]').text()
                htmlVylepseni += '<div class="inner dodatecne" data-price="'+productPrice+'" data-sku="'+productSKU+'">'
                    htmlVylepseni += '<div class="image">'
                        htmlVylepseni += '<img src="'+productImage+'" alt="'+productName+'">'
                    htmlVylepseni += '</div>'
                    htmlVylepseni += '<div class="text">'+productName+'<span class="price">'+Number(productPrice).ShoptetFormatAsCurrency()+'</span></div>'
                htmlVylepseni += '</div>'
            })
            htmlVylepseni += '</div></td></tr>'
            $('.surcharge-list').last().after(htmlVylepseni)
        }
        $(document).on('click', '.add-to-cart .add-to-cart-button', function(){
            $('.inner.dodatecne').each(function(){
                if($(this).hasClass('active')){
                    
                    shoptet.cartShared.addToCart({productCode: ''+$(this).attr('data-sku')+''});
                }
            })
        })
    }
  
    else{

        if($('.surcharge-list').length){
           
            $('.surcharge-list').each(function(){
                var parameterId = $(this).find('select').data('parameter-id')
                var html = '<div class="custom-surcharge">'
                $(this).find('option').each(function(){
                    if ($.isNumeric($(this).val())) {
                        html += '<div class="inner" data-select-id="'+parameterId+'" data-value="'+$(this).attr('value')+'" data-price="'+$(this).attr('data-surcharge-final-price')+'">'
                            html += '<div class="image">'
                                html += '<img src="/user/documents/upload/'+imageFolder +"/a-" +$(this).attr('value') +'.jpg" alt="'+$(this).text().split('+')[0].trim()+'">'
                            html += '</div>'
                            html += '<div class="text">'
                                html += $(this).text().split('+')[0].trim()
                                html += '<span class="price">'+$(this).text().split('+')[1].trim()+'</span>'
                            html += '</div>'
                            if($('.admin-logged').length){
                                html += '<div class="admin-logged">'+$(this).attr('value')+'.jpg</div>'
                            }
                        html += '</div>'
                    }
                })
                html += '</div>'
                $(this).find('td').append(html)
            })
        }
        if($('.variant-list').length){
            $('.variant-list').each(function(){
                var parameterId = $(this).find('select').data('parameter-id')
                var html = '<div class="custom-variant" data-param-id="'+parameterId+'">'
                $(this).find('option').each(function(){
                    if ($.isNumeric($(this).val())) {
                        html += '<div class="inner" data-parameter-id="'+parameterId+'" data-value="'+$(this).attr('value')+'" data-price="'+$(this).attr('data-surcharge-final-price')+'">'
                            html += '<div class="image">'
                                html += '<img src="/user/documents/upload/'+imageFolder +"/a-" +$(this).attr('value') +'.jpg" alt="'+$(this).text().split('+')[0].trim()+'">'
                            html += '</div>'
                            html += '<div class="text">'
                                html += $(this).text()
                               // html += '<span class="price">'+$(this).text()+'</span>'
                            html += '</div>'
                            if($('.admin-logged').length){
                                html += '<div class="admin-logged">'+$(this).attr('value')+'.jpg</div>'
                            }
                        html += '</div>'
                    }
                })
                html += '</div>'
                $(this).find('td').append(html)
            })
        }
    }
}



$(document).on('click', '.custom-surcharge .inner:not(".dodatecne")', function(){
    const variantData = $(this).data('value')
    const variantParameterId = $(this).data('select-id')
    $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){return $(this).attr('value') == variantData }).change().prop("selected", true)
    $(this).closest('.custom-surcharge').find('.inner:not([data-value="'+variantData+'"])').removeClass('active')
    $(this).addClass("active");
    var total = 0
    $(".custom-surcharge .inner.active").each(function() {
        var value = parseInt($(this).attr("data-price"));
        if (!isNaN(value)) {
            total += value;
        }
    });
    console.log(total);
    var finalPrice = parseFloat($('.price-final-holder.calculated:not(.noDisplay)').attr('data-price'));
    $('.p-final-price-wrapper .price-final .calculated-price').html(Number(finalPrice+total).ShoptetFormatAsCurrency())
})

$(document).on('click', '.custom-surcharge .inner.dodatecne', function(){
    const variantData = $(this).data('value')
    const variantParameterId = $(this).data('select-id')
    $(this).toggleClass("active");
    var total = 0
    $(".custom-surcharge .inner.active").each(function() {
        var value = parseInt($(this).attr("data-price"));
        if (!isNaN(value)) {
            total += value;
        }
    });
    console.log(total);
    var finalPrice = parseFloat($('.price-final-holder.calculated:not(.noDisplay)').attr('data-price'));
    $('.p-final-price-wrapper .price-final .calculated-price').html(Number(finalPrice+total).ShoptetFormatAsCurrency())
})

$(document).on('click', '.custom-variant .inner', function(){
    const variantData = $(this).data('value')
    const variantParameterId = $(this).data('parameter-id')
    $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){return $(this).attr('value') == variantData }).change().prop("selected", true)
    var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
    var $splitParameters = $(selector);
    $splitParameters.trigger('change');
    $(this).closest('.custom-variant[data-param-id="'+variantParameterId+'"]').find(".inner:not([data-value='"+variantData+"'])").removeClass("active");
    $(this).addClass("active");    
    $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    $('.custom-variant .inner').each(function(){
        const variantData = $(this).data('value')
        const variantParameterId = $(this).data('parameter-id')
        const unavailable = $("select[data-parameter-id='"+variantParameterId+"']  option[value='" + variantData + "']").hasClass("unavailable-option")    
        if (unavailable === true) {
            $(this).addClass("unavailable").removeClass("active")
        }
        else{
            $(this).removeClass("unavailable")
        } 
    })
    
   
})